<template>
	<button type="button" id="add-song-button" @click="addSong"><IconPlus />&nbsp;<span>{{ $t('song.addToSongbook') }}</span></button>
</template>

<script>
	import IconPlus from "@/components/icons/IconPlus"
	import { SongService } from "@/services/SongService";
	import { mapState } from "vuex";

	export default {
		components: {
			IconPlus
		},
		computed: {
			...mapState([ "currentSong", "localSearchOpened", "externalSearchOpened", "currentUser" ])
		},
		methods: {
			addSong() {
				if (Object.values(this.$store.state.songs).length >= 5 && this.currentUser.isAnonymous) {
					this.$modal.show("login-registration");
					return;
				} else if (Object.values(this.$store.state.songs).length >= 20 && (this.$store.state.datetimeMembershipExpire === null || this.$store.state.datetimeMembershipExpire < new Date)) {
					this.$modal.show("need-membership");
					return;
				}
				/* eslint-disable */ fbq("track", "AddToWishlist");
				this.$store.commit("setCurrentSong", SongService.addSong(this.currentSong));
				this.$notify({
					type: "success",
					text: this.$t("notification.songAddedToSongbook"),
				});
			},
			keydownEvent(e) {
				if (this.localSearchOpened) return;
				if (!this.externalSearchOpened) return;
				if (e.srcElement.tagName === "INPUT" || e.srcElement.tagName === "TEXTAREA") return;
				if (e.code === "Enter") {
					this.addSong();
				}
			}
		},
		mounted() {
			document.addEventListener("keyup", this.keydownEvent);
		},
		destroyed() {
			document.removeEventListener("keyup", this.keydownEvent);
		},
	}

</script>

<style lang="scss" scoped>
	button#add-song-button {
		background-color: #ef904e;
		color: rgba(255, 255, 255, 0.75);

		&:hover {
			background-color: #d07a46;
		}

		.icon-plus {
			width: 18px;
			margin: 5px 0 0 -7px;
			float: left;
			position: absolute;
			fill: rgba(255, 255, 255, 0.79);
		}

		span {
			margin-left: 18px;
		}

		@media only screen and (max-width: 660px) {
			span {
				display: none;
			}
		}


	}
</style>
